import { render, staticRenderFns } from "./DecisionAiCoachList.vue?vue&type=template&id=a40db868&scoped=true"
import script from "./DecisionAiCoachList.vue?vue&type=script&lang=js"
export * from "./DecisionAiCoachList.vue?vue&type=script&lang=js"
import style0 from "./DecisionAiCoachList.vue?vue&type=style&index=0&id=a40db868&prod&lang=scss&scoped=true"
import style1 from "./DecisionAiCoachList.vue?vue&type=style&index=1&id=a40db868&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40db868",
  null
  
)

export default component.exports